import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

const Layout = ({ children }) => {
  const location = useLocation();

  // Scroll to top en cada cambio de ruta
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location.pathname]);

  return (
    <>
      <Header />
      <main className="min-h-screen w-full">
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
    </>
  );
};

export default Layout;
